import React, {Component} from 'react';
import Edit from 'react-feather/dist/icons/edit.js';
import Trash from 'react-feather/dist/icons/trash.js';
import ChevronDown from 'react-feather/dist/icons/chevron-down.js';
import ChevronUp from 'react-feather/dist/icons/chevron-up.js';
import PropTypes from 'prop-types';

import connectModal from '../../../../../shared/components/Modals/connect.js';
import Date from '../../../../../shared/components/Moment/Date.jsx';
import MissionModal from "../../../../components/Modals/Mission/MissionModal.jsx";
import DeleteMissionModal from "../../../../components/Modals/Mission/DeleteMissionModal.jsx";
import PrimaryRoundedButton from "../../../../../shared/components/Styled/Buttons/PrimaryRoundedButton.jsx";
import DangerRoundedButton from "../../../../../shared/components/Styled/Buttons/DangerRoundedButton.jsx";
import SecondaryRoundedButton from "../../../../../shared/components/Styled/Buttons/SecondaryRoundedButton.jsx";
class Missions extends Component {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
    experiences: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      experiencesVisibility : []
    }
  }

  componentDidMount() {
    const { experiences } = this.props;
  
    const visibilityArray = experiences?.map((_, index) => true);
  
    this.setState({
      experiencesVisibility: visibilityArray
    });
  }

  editExistingMission = (offset, experienceId) => {
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.props.experiences,
      onClose: this.props.onClose,
      onSubmit: this.props.submit,
      offset,
      experienceId
    });
  };

  deleteMission = (offset, experienceId) => {
    this.props.openDeleteMissionModal({
      freelance: this.props.freelance,
      experiences: this.props.experiences,
      onClose: this.props.onClose,
      offset,
      experienceId
    });
  };

  toggle = (offset) => {
    this.setState((prevState) => {
      const updatedVisibility = [...prevState.experiencesVisibility];
      updatedVisibility[offset] = !updatedVisibility[offset];
      return { experiencesVisibility: updatedVisibility };
    });
  };

  isVisible = (offset) => {
    const { experiencesVisibility } = this.state;
    return experiencesVisibility[offset] ?? false;
  };

  render() {
    return (
      <div>
        {this.props.experiences.map((experience, offset) => (
          <div className={this.props.className} key={offset} id={`experiences-${offset}`}>

            <div style={{display: 'flex'}}>
              <div style={{flex: 'auto'}}><h3 className="sub-sub-title">{experience.title }</h3></div>
              <div>{this.props.canEdit &&
                <div className="controls">
                  <PrimaryRoundedButton className={"mr-2"} onClick={() => this.editExistingMission(offset, experience.id)}>
                    <Edit />
                  </PrimaryRoundedButton>
                  <DangerRoundedButton className={"mr-2"} onClick={() => this.deleteMission(offset, experience.id)}>
                    <Trash />
                  </DangerRoundedButton>
                  <SecondaryRoundedButton onClick={() => this.toggle(offset)}>
                    {this.isVisible(offset) ? <ChevronUp /> : <ChevronDown />}
                  </SecondaryRoundedButton>
                </div>
              }</div>
            </div>

            {(experience.title || experience.locality || experience.company) &&
              <div>
                {experience.title && experience.company && <span> chez </span>}
                {experience.company && <b>{experience.company}</b>}
                {(experience.company || experience.title) && experience.locality && <span> - </span>}
                {experience.locality && <span>{experience.locality}</span>}
              </div>
            }

            {(experience.start || experience.end || experience.current) &&
              <div>
                {(experience.start && <Date format="MM/yyyy" date={experience.start} />)}
                {(experience.start && (experience.current || experience.end) && <span> - </span>)}
                {(experience.current
                  ? <span>Aujourd'hui</span>
                  : (experience.end && <Date format="MM/yyyy" date={experience.end} />)
                )}
              </div>
            }

            { this.isVisible(offset) ? <div className="mt-4" dangerouslySetInnerHTML={{__html: experience.description}}/> : '' }
          </div>
        ))}
      </div>
    );
  }
}

export default connectModal({ MissionModal, DeleteMissionModal }, Missions);